function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1 2.8c0-.566 0-.848.176-1.024C1.352 1.6 1.634 1.6 2.2 1.6h9.6c.566 0 .848 0 1.024.176C13 1.952 13 2.234 13 2.8c0 .566 0 .848-.176 1.024C12.648 4 12.366 4 11.8 4H2.2c-.566 0-.848 0-1.024-.176C1 3.648 1 3.366 1 2.8z",
  fill: "currentColor"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.841 4.9l.259-.001V7.6c0 2.263 0 3.394-.703 4.097-.703.703-1.834.703-4.097.703h-.6c-2.263 0-3.394 0-4.097-.703C1.9 10.994 1.9 9.863 1.9 7.6V4.899l.259.001h9.682zM5.2 7c0-.28 0-.42.046-.53a.6.6 0 01.324-.324c.11-.046.25-.046.53-.046h1.8c.28 0 .42 0 .53.046a.6.6 0 01.324.324c.046.11.046.25.046.53s0 .42-.046.53a.6.6 0 01-.324.324c-.11.046-.25.046-.53.046H6.1c-.28 0-.42 0-.53-.046a.6.6 0 01-.324-.324C5.2 7.42 5.2 7.28 5.2 7z",
  fill: "currentColor"
});

var SvgArchive = function SvgArchive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgArchive;